import React, { Component } from 'react'
import PageTitle from '../../commons/components/PageTitle';
import styled from 'styled-components';
import TitleWithCard from './ui/TitleWithCard';
import DrButton from './ui/DrButton';
import { DR_BUTTON_TEXT, SORT_TYPE } from './model/drButtonType';
import DoughnutChart from './ui/DoughnutChart';
import BarChart from './ui/BarChart.jsx';
import HistoryTable from './ui/HistoryTable';
import ListTable from '../../commons/components/ListTable';
import AS from "../Login/Service/Authentication.js";
import PS from '../PlantList/MonitoringApiService.js';
import MS from '../../commons/services/Moment.js';
import axios from 'axios';
import { generateCarrierKey } from './model/generateCarrierKey.js';
import _ from 'lodash';
import { ROUTES } from '../../commons/constants/routes/routes.js';
import { withTranslation } from 'react-i18next';
import { TableCellsWidth } from './model/translationUiConst.js';

class Dr extends Component {
  constructor(props) {
    super(props);
    this.state = {
      graphData: [],
      deviceTypeMapping: [],
      devices: [],
      uniqueCarrierKeyList: [],
      drDevices: [],
      drResourceIdxList: [],
      drHistory: [],
      emsCarrierData: [],
      clbChartData: [],
      filteredDrDevices: [], // mongoDB와 일치하는 drNo를 가진 drDevices
      filterData: {
        drButtonText: DR_BUTTON_TEXT.ALL,
        sort: SORT_TYPE.CREATE,
        sortActive: true
      },
      urlParamDate: null,
    };

    this.handleChangeSort = this.handleChangeSort.bind(this);
    this.handleChangeDrButton = this.handleChangeDrButton.bind(this);
  }

  async componentDidMount() {
    await this.fetchType();
    await this.getDrDevice();
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.filterData !== this.state.filterData) {
      this.setFilteredDrDevices();
    }
    if (prevState.drResourceIdxList !== this.state.drResourceIdxList) {
      this.getDrHistory();
    }
    if (prevState.uniqueCarrierKeyList !== this.state.uniqueCarrierKeyList) {
      this.getDevicePower();
    }
    if (prevProps.location !== this.props.location) {
      this.getDrClb();
      this.updateUrlParam();
    }
  }

  async fetchType() {
    try {
      const response = await axios.get(`/cst/api/deviceType`);
      this.setState({ deviceTypeMapping: response.data });
    } catch (error) {
      console.error("전력기기 타입 조회 실패", error);
    }
  }

  async getDrDevice () {
    let constructorId = AS.getLoggedInId();
    try {
      const res = await axios.get(`/cst/api/device/${constructorId}`);
      if (!res || !res.data || !res.data.data) return;

      const devices = res.data.data;
      const drDevices = devices.filter((device) => device.drResIdx);
      const drResourceIdxList = drDevices.map((device) => device.drResIdx);
      const uniqueDrResourceIdxList = [...new Set(drResourceIdxList)];
      const uniqueCarrierKeyList = generateCarrierKey(drDevices);
      this.setState({ devices: devices, drResourceIdxList: uniqueDrResourceIdxList, uniqueCarrierKeyList }, this.setDrDevices(devices));

    } catch (error) {
      console.error('Error: ', error);
    }
  }

  setDrDevices(devices) {
    const filteredDrDevices = devices.filter(device => {
      return device.drResIdx && device.drContr === 1;
    });
    const all = filteredDrDevices.length;
    const run = filteredDrDevices.filter(device => device.drYn === 1).length;
    this.setState({
      drDevices: filteredDrDevices,
      filteredDrDevices,
      graphData: [null, run, all]
    });
  }

  setFilteredDrDevices() {
    const { filterData } = this.state;
    const { t } = this.props;
    const filteredDrDevices = this.state.drDevices.filter(device => {
      switch (filterData.drButtonText) {
        case t(DR_BUTTON_TEXT.ALL):
          return true;
        case t(DR_BUTTON_TEXT.ENABLED):
          return device.drYn === 1;
        case t(DR_BUTTON_TEXT.DISABLED):
          return !device.drYn;
        default:
          return true;
      }
    });

    this.setState({
      filteredDrDevices
    }, () => this.setSortDrDevices());
  }

  setSortDrDevices() {
    const { filterData, filteredDrDevices } = this.state;
    const { t } = this.props;
    const sortName = filterData.sort;
    const sortType = filterData.sortActive ? "asc" : "desc";

    const sortedDrDevices = [...filteredDrDevices];

    if (sortName === t(SORT_TYPE.DEVICE)) {
      const priority = {
        1: 4, // 보일러 : 순서
        4: 3, // 축열조 : 순서
        2: 2, // 조명 : 순서
        3: 1  // 공조기 : 순서
      };
      const result = _.orderBy(sortedDrDevices, (device) => priority[device.typeId], sortType);

      this.setState({
        filteredDrDevices: result
      });
    }

    if (sortName === t(SORT_TYPE.CREATE)) {
      const result = _.orderBy(sortedDrDevices, (device) => new Date(device.createDt), sortType);
      
      this.setState({
        filteredDrDevices: result
      });
    }

    if (sortName === t(SORT_TYPE.CONS)) {
      const result = _.orderBy(sortedDrDevices, (device) => device.pwConsumption, sortType);

      this.setState({
        filteredDrDevices: result
      });
    }
  }

  async getDrHistory() {
    const { drResourceIdxList } = this.state;

    const param = {
      drResourceIdxList,
      lastDateCount: 4
    }
    try {
      const result = await axios.post("/cst/api/device/dr/history", param);
      this.setState({
        drHistory: result?.data?.plusDrList || []
      })
    } catch (error) {
      console.error(error);
    }
  }

  async getDrClb() {
    const locateState = this.props.location.state;

    if (!locateState) {
      this.setState({
        clbChartData: []
      });
    } else {
      const { logIds, date } = locateState;
      const param = {
        drResourceInxList: logIds,
        date
      }
      try {
        const result = await axios.post("/cst/api/device/dr/clb/chart", param);
        
        const clbData = fillMissingHours(result?.data);
        this.setState({
          clbChartData: clbData || []
        })
      } catch (error) {
        console.error(error);
      }
    }
  }

  async fetchDeviceDataByProjectId(projectId) {
    let data = {
      projectId: projectId,
      sortBy: "",
    };

    try {
      const result = await axios.post("/cst/api/device/search", data);
      const resData = result.data.data.reverse();
      return resData;
      
    } catch (error) {
      console.error("전력기기 정보 불러오기 실패", error);
    }
  }

  async getDevicePower() {
    const { uniqueCarrierKeyList } = this.state;
    const param = {
      carrierSerialNos: uniqueCarrierKeyList,
      date: MS.current("YYYY-MM-DD")
    }

    try {
      const result = await PS.getEmsCarrierData(param);
      const sortedResult = result.sort((a, b) => a.hh - b.hh);
      this.setState({
        emsCarrierData: result || []
      })
    } catch (error) {
      console.error(error);
    }
  }

  updateUrlParam() {
    const { drHistory } = this.state;
    const { location } = this.props;
    const searchParams = new URLSearchParams(location.search);
    const date = searchParams.get('date');

    // const drHistoryDateByDate = drHistory.filter((item) => new Date(item.dt).getTime() === new Date(date).getTime());
    
    // const 
    this.setState({
      urlParamDate: date,
    })
  }

  handleChangeSort = (event) => {
    const { filterData } = this.state;

    if (filterData.sort === event && filterData.sortActive) {
      this.setState({
        filterData: {
          ...this.state.filterData,
          sort: event,
          sortActive: false,
        }
      });
      return;
    }
    if (filterData.sort === event && !filterData.sortActive) {
      this.setState({
        filterData: {
          ...this.state.filterData,
          sort: event,
          sortActive: true,
        }
      });
      return;
    }
    if (filterData.sort !== event) {
      this.setState({
        filterData: {
          ...this.state.filterData,
          sort: event,
          sortActive: true,
        }
      });
      return;
    }
    
  }

  handleChangeDrButton = (buttonText) => {
    this.setState({
      filterData: {
        ...this.state.filterData,
        drButtonText: buttonText,
      }
    });
  }
  
  handleDetailOrDetailLinkClick = async (device, type) => {
    
    const projectId = device.projectId;
    const deviceList = await this.fetchDeviceDataByProjectId(projectId) || [];
    const deviceTypeMapping = this.state.deviceTypeMapping;
    const url = type === "detail" ? ROUTES.PLANT_LIST(projectId).POWER_DETAIL_CARRIER : ROUTES.PLANT_LIST(projectId).POWER_EDIT(device.id);
    const result = await axios.get(`/cst/api/project/id/${projectId}`);
    const projectName = result.data.name;
    localStorage.setItem("projectTitle", projectName);

    this.props.history.push({
      pathname: url,
      state: {
        projectId: projectId,
        device: device,
        deviceList: deviceList,
        deviceData: deviceList,
        deviceTypeMapping: deviceTypeMapping,
      }
    })
  }
  
  render() {
    const { drDevices, filterData, filteredDrDevices, graphData, drHistory, emsCarrierData, urlParamDate } = this.state;
    const lineGraphData = emsCarrierData.map((item) => item?.day_total_cons_power);
    const lineGraphLabel = emsCarrierData.map((item) => item?.hh);

    const { t, i18n } = this.props;

    return (
      <>
        <PageTitle title="+DR" location={urlParamDate ? MS.format(urlParamDate, "MM/DD일") : null}/>
        <Container>
          <Grid>
            <TitleWithCard title={t("key7")}>
              <DoughnutChart data={graphData}/>
            </TitleWithCard>
            <TitleWithCard title={t("key10")}>
              <BarChart 
                data={lineGraphData}
                label={lineGraphLabel}
                labelName={t("key26")}
                unit={"kWh"}
              />
            </TitleWithCard>
            <TitleWithCard title={urlParamDate 
              ? t("key30")
              : t("key11")}>
              {
                urlParamDate ? (
                  <BarChart 
                    data={this.state.clbChartData.map((item) => item?.clb)}
                    label={this.state.clbChartData.map((item) => item?.hh)}
                    labelName="CLB"
                  />
                ) : (
                  <HistoryTable data={drHistory}/>
                )
              }
            </TitleWithCard>
            <DrButton 
              text={t(DR_BUTTON_TEXT.ALL)} 
              isActive={t(DR_BUTTON_TEXT.ALL) === filterData.drButtonText}
              onClick={() => this.handleChangeDrButton(t(DR_BUTTON_TEXT.ALL))}
            />
            <DrButton 
              text={t(DR_BUTTON_TEXT.ENABLED)} 
              isActive={t(DR_BUTTON_TEXT.ENABLED) === filterData.drButtonText}
              onClick={() => this.handleChangeDrButton(t(DR_BUTTON_TEXT.ENABLED))}
            />
            <DrButton 
              text={t(DR_BUTTON_TEXT.DISABLED)} 
              isActive={t(DR_BUTTON_TEXT.DISABLED) === filterData.drButtonText}
              onClick={() => this.handleChangeDrButton(t(DR_BUTTON_TEXT.DISABLED))}
            />
          </Grid>
          <ListTable
            title={t(filterData.drButtonText)}
            totalCount={filteredDrDevices.length}
            header={[t('key21A'), `${t('key22')} ${t('key23')}`, t('key24'), t('key25'), t('key26'), t('key27'), '']}
            cellWidth={TableCellsWidth(i18n)}
            sortButton={Object.entries(SORT_TYPE).map(([key, value]) => t(value))}
            activeSortButton={(filterData.sort && filterData.sortActive) ? filterData.sort : null}
            onChangeSort={(event) => this.handleChangeSort(event)}
          >
            {
              filteredDrDevices.length === 0 ? (
                <tr>
                  <td colSpan={7}>
                    <p>{t("key30A")}</p>
                  </td>
                </tr>
              ) : (
                filteredDrDevices.map(({ typeId, name, modelName, pwConsumption, serviceWarrantyDt }, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td>
                      {
                        this.state.deviceTypeMapping.find(
                          (mapping) => mapping.id === typeId
                        )?.type || t("key30B")
                      }
                    </td>
                    <td>{name}</td>
                    <td>{modelName}</td>
                    <td>{pwConsumption}kW</td>
                    <td>{serviceWarrantyDt}</td>
                    <td>
                      <button 
                        className="detail-link"
                        onClick={() => this.handleDetailOrDetailLinkClick(filteredDrDevices[idx], "detail")}
                      >
                        {t("key28")}
                      </button>
                      <button
                        className="edit-link"
                        onClick={() => this.handleDetailOrDetailLinkClick(filteredDrDevices[idx], "edit")}
                      >
                        {t("key29")}
                      </button>
                    </td>
                  </tr>
                ))
              )
            }
          </ListTable>
        </Container>
      </>
    );
  }
}

const Container = styled.div`
  width: 1176px;
  margin: 30px auto 0;
`;
const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-bottom: 24px;
`;
const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;

  & > button:first-child {
    width: 62px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    background-color: rgba(255, 211, 93, 1);
    border-radius: 5px;
    border: none;
    font-size: 12px;
  }

  & > button:last-child {
    width: 41px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    background-color: rgba(89, 191, 118, 1);
    border-radius: 5px;
    border: none;
    font-size: 12px;
    color: white;
  }
`;
export default withTranslation()(Dr);

function fillMissingHours(data) {
  const fullResult = [];

  if (!data || !Array.isArray(data)) {
    return fullResult;
  }

  for (let hour = 0; hour < 24; hour++) {
    const hh = hour.toString().padStart(2, "0");
    const existing = data?.find(item => item.hh === hh);

    fullResult.push({
      hh,
      clb: existing ? existing.clb : 0.0
    });
  }

  return fullResult;
}